import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface DocumentEditProps {
  onSubmit: () => void;
  documentId: string;
  filename: string;
}

export const DocumentEdit = ({ onSubmit, documentId, filename }: DocumentEditProps) => {
  const api = useApi();
  const [newName, setNewName] = useState<string>(filename);

  const updateFilename = useMutation(api.updateDocumentApiV1UpdateDocumentPost, {
    onSuccess() {
      toast.success('Document file name changed successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    updateFilename.mutate({
      document_id: documentId,
      filename: newName
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="New Filename"
        variant="outlined"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        autoFocus
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
